import { ClientTelerikReportPage } from "../components/ClientTelerikReportPage";
import { CLIENTS_ALL_ROLES } from "../../SharedModule/utils/constants";

export const ClientAdvocacySummaryReportPage = () => (
  <ClientTelerikReportPage
    documentTitle="The Hub - Advocacy Summary Report"
    reportTitle="Advocacy Summary Report"
    reportName="ClientAdvocacySummary.trdp"
    allowedRoles={CLIENTS_ALL_ROLES}
    parametersAreaVisible={false}
  />
);
